<template>
    <div id="filter-account__responsive-button" @click="responsiveOpenFilter">
        <iconFilterButton class="d-block" />
    </div>
</template>

<script>
import iconFilterButton from '@/assets/img/account/header/filter-button.svg?inline';

export default {
    components: {
        iconFilterButton
    },

    methods: {
        responsiveOpenFilter() {
            if (!document.body.classList.contains('filter-account__open')) {
                document.body.classList.add('filter-account__open');
            } else {
                document.body.classList.remove('filter-account__open');
            }
        }
    }
};
</script>
